import { SlotsToClasses } from "@heroui/react";


type ToastColorType = "primary" | "default" | "foreground" | "secondary" | "success" | "warning" | "danger" | undefined;
export type ToastSettings = {
    maxVisibleToasts?: number | undefined;
    timeout: number;
    theme: "light" | "dark" | "colored" | undefined;
    radius?: "full" | "lg" | "md" | "none" | "sm" | undefined;
    color?: ToastColorType;
    placement?: "top-left" | "top-right" | "top-center" | "bottom-left" | "bottom-right" | "bottom-center" | undefined;
    variant?: "bordered" | "flat" | "solid" | undefined
    hideIcon?: boolean | undefined;
    classNames?: SlotsToClasses<"base" | "closeButton" | "closeIcon" | "content" | "description" | "icon" | "loadingComponent" | "motionDiv" | "progressIndicator" | "progressTrack" | "title" | "wrapper"> | undefined
    mobileOffset?: number | undefined;
};

export const toastSettings: ToastSettings = {
    timeout: 1000,
    placement: "bottom-right",
    theme: "dark",
    radius: "md",
    color: "secondary",
    variant: "bordered",
    hideIcon: false,
    maxVisibleToasts: 6,
    mobileOffset: 20,
}
